import { UAParser } from "ua-parser-js";

let deferredPrompt: BeforeInstallPromptEvent | null = null;

// capture beforeinstallprompt
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
});

export function isPWAInstalled() {
  if (
    window?.matchMedia?.("(display-mode: minimal-ui)").matches ||
    window?.matchMedia?.("(display-mode: standalone)").matches ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ("standalone" in navigator && (navigator as any).standalone === true)
  ) {
    return true;
  }

  return false;
}

export async function getPWAInstallInstructions() {
  // already installed?
  if (isPWAInstalled()) {
    return "App is already installed.";
  }

  // install prompt available
  if (deferredPrompt) {
    await deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    deferredPrompt = null;
    if (choiceResult.outcome === "accepted") {
      return "App installation started.";
    } else {
      return "Installation dismissed.";
    }
  }

  // fallback: use UA
  const parser = new UAParser(navigator.userAgent);
  const result = parser.getResult();
  const os = result.os.name || "";
  const browser = result.browser.name || "";

  // iOS
  if (os === "iOS") {
    if (browser === "Mobile Safari") {
      return "On iOS, tap the Share button in Safari and select 'Add to Home Screen'.";
    } else {
      return "On iOS, install via Safari only. Open this site in Safari.";
    }
  }

  // Android
  if (os === "Android") {
    if (
      browser === "Chrome" ||
      browser === "Samsung Browser" ||
      browser === "Edge"
    ) {
      return "Open this site in Chrome (or supported browser) on Android, then tap the menu and 'Add to Home screen'.";
    } else {
      return "Your browser on Android does not support install. Use Chrome, Edge, or Samsung Browser.";
    }
  }

  // macOS
  if (os === "Mac OS") {
    if (browser === "Chrome" || browser === "Edge") {
      return "In Chrome/Edge on macOS, go to the address bar menu and select 'Install App'.";
    } else if (browser === "Safari") {
      return "Safari on macOS does not support install. Use Chrome or Edge.";
    }
  }

  // Windows / Linux desktop
  if (os === "Windows" || os === "Linux") {
    if (browser === "Chrome" || browser === "Edge" || browser === "Brave") {
      return "In Chrome/Edge/Brave, click the install icon in the address bar to install.";
    } else if (browser === "Firefox") {
      return "Firefox does not support install. Use Chrome or Edge.";
    }
  }

  // default
  return "Your device or browser does not support installation.";
}
